import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import AuthService from './AuthService';

export class SilentRenew extends React.Component<RouteComponentProps<string>, {}> {
  authService: AuthService;

  constructor(props: RouteComponentProps<string>) {
    super(props);
    this.authService = new AuthService();
  }
  componentDidMount = async () => {
    await this.authService.signinSilentCallback();
  }

  render = () => (
    <></>
  )
}